import { mpsToKmh } from '@rcs/domain';
import { messages } from '../i18n/ja';
import type { ComputeOutcome } from '../worker/client';

/** 試算の結果（全長・所要時間・最高速度・最大上下 G）を表示する。 */
export function RideSummary({ outcome }: { readonly outcome: ComputeOutcome | undefined }) {
  const t = messages.summary;
  return (
    <div className="ride-summary" data-testid="ride-summary" role="status">
      <strong>{t.title}</strong>
      {outcome === undefined && <span>{t.computing}</span>}
      {outcome?.status === 'error' && <span>{`${t.failed}${outcome.message}`}</span>}
      {outcome?.status === 'ok' && (
        <span data-testid="ride-summary-values">
          {`${t.length} ${outcome.value.track.length.toFixed(0)} m / ${t.duration} ${outcome.value.stats.duration.toFixed(1)} s / ${t.maxSpeed} ${mpsToKmh(outcome.value.stats.maxSpeed).toFixed(0)} km/h / ${t.maxG} ${outcome.value.stats.maxVerticalG.toFixed(2)} G`}
        </span>
      )}
    </div>
  );
}
